import Axios from '@/axios';

// 新增一个访客授权
export const createVisitorAuth = data => {
  return Axios({
    url: '/face/web/dept_auth/create_visitor_dept_auth',
    method: 'POST',
    type: 'json',
    data
  })
}
// 删除一个访客授权
export const deleteVisitorAuth = data => {
  return Axios({
    url: '/face/web/dept_auth/delete_visitor_dept_auth',
    method: 'POST',
    type: 'json',
    data
  })
}
// 分页查询某机构已授权的设备列表
export const getOrgAuthedDevices = params => {
  return Axios({
    url: '/face/web/dept_auth/index_visitor_dept_auth_device',
    method: 'GET',
    type: 'json',
    params
  })
}
// 分页查询某机构未授权的设备列表
export const getOrgUnauthedDevices = params => {
  return Axios({
    url: '/face/web/dept_auth/index_visitor_dept_not_auth_device',
    method: 'GET',
    type: 'json',
    params
  })
}
// 分页查询某机构未授权的设备列表
export const showAppointmentApplyExamine = data => {
  return Axios({
    url: '/face/web/appointment/show_appointment_apply_examine',
    method: 'POST',
    type: 'json',
    data
  })
}
